import { useIntl } from 'react-intl';
import { Chip, Stack, Typography } from '@rossum/ui/material';
import { PreviewDrawer } from '../../ui/PreviewDrawer';
import { EnumAndFormulaCellValue } from '../columns/types';
import { ReasoningPreview } from './components/ReasoningPreview';

type ReasoningDrawerProps = {
  onClose: () => void;
  reasoningForDrawer: {
    prompt: string;
    context: string[];
    value: EnumAndFormulaCellValue;
  } | null;
};

export const ReasoningDrawer = ({
  onClose,
  reasoningForDrawer,
}: ReasoningDrawerProps) => {
  const intl = useIntl();

  return (
    <PreviewDrawer
      onClose={onClose}
      open={!!reasoningForDrawer}
      title={reasoningForDrawer?.value.label ?? ''}
      subtitle={intl.formatMessage(
        {
          id: 'features.fieldManager.fieldDetail.enumFormulaEditing.reasoningDrawer.subtitle',
        },
        { count: reasoningForDrawer?.value.count }
      )}
      content={
        <Stack spacing={2}>
          {reasoningForDrawer?.context &&
          reasoningForDrawer.context.length > 0 ? (
            <Stack spacing={1}>
              <Typography variant="caption" color="text.secondary">
                {intl.formatMessage({
                  id: 'features.fieldManager.fieldDetail.enumFormulaEditing.reasoningDrawer.context',
                })}
              </Typography>
              <Stack direction="row" flexWrap="wrap" gap={0.5}>
                {reasoningForDrawer.context.map(item => (
                  <Chip key={item} label={item} size="small" />
                ))}
              </Stack>
            </Stack>
          ) : null}
          {reasoningForDrawer?.prompt ? (
            <Stack spacing={1}>
              <Typography variant="caption" color="text.secondary">
                {intl.formatMessage({
                  id: 'features.fieldManager.fieldDetail.enumFormulaEditing.reasoningDrawer.prompt',
                })}
              </Typography>
              <ReasoningPreview value={reasoningForDrawer.prompt} />
            </Stack>
          ) : null}
        </Stack>
      }
    />
  );
};
